











import { Component, Vue, Provide } from 'vue-property-decorator';

@Component({})
export default class Footer extends Vue {
    @Provide() public tab: string = '1';

    public switchtab(newTab: string) {
        this.$emit('changetab', parseInt(newTab, 10));
    }
}
